import { useEffect, useRef } from 'react';

const Hero = () => {
  const sectionRef = useRef(null);
  const glowRef = useRef(null);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  useEffect(() => {
    const section = sectionRef.current;
    const glow = glowRef.current;
    if (!section || !glow) return;

    // Default position: centre-left of hero
    const rect = section.getBoundingClientRect();
    glow.style.transform = `translate(${rect.width * 0.25 - 300}px, ${rect.height * 0.45 - 300}px)`;

    const onMouseMove = (e) => {
      const r = section.getBoundingClientRect();
      const x = e.clientX - r.left;
      const y = e.clientY - r.top;
      glow.style.transform = `translate(${x - 300}px, ${y - 300}px)`;
    };

    section.addEventListener('mousemove', onMouseMove);
    return () => section.removeEventListener('mousemove', onMouseMove);
  }, []);

  return (
    <section className="hero" id="home" ref={sectionRef}>
      {/* Mouse-following red glow */}
      <div className="hero-mouse-glow" ref={glowRef} />

      {/* Glass noise texture */}
      <div className="hero-glass-overlay" />

      <div className="container hero-content">
        <div className="hero-eyebrow reveal">
          <span className="hero-dot" />
          <span>Africa's Leading Digital Agency</span>
        </div>

        <h1 className="hero-heading reveal" data-delay="100">
          We Make<br />
          <span className="red">Bold Brands</span><br />
          Impossible<br />
          to Ignore.
        </h1>

        <p className="hero-sub reveal" data-delay="200">
          Creative strategy. Striking design. Data-driven results.
          <br />
          Raddish Media turns brands into movements.
        </p>

        <div className="hero-actions reveal" data-delay="300">
          <button className="btn-primary btn-lg" onClick={() => scrollTo('services')}>
            Explore Services
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M5 12h14M12 5l7 7-7 7"/>
            </svg>
          </button>
          <button className="btn-outline btn-lg" onClick={() => scrollTo('contact')}>
            Start a Project
          </button>
        </div>

        <div className="hero-scroll-hint reveal" data-delay="500" onClick={() => scrollTo('services')}>
          <div className="scroll-line" />
          <span>Scroll to explore</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
